import { Box, Card, Dialog } from '@mui/material';
import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';

import useIsMobile from '../../../../../../hooks/isMobile';
import OpenEyesLogo from '../../assets/openeyes-logo.svg';
import SetupToolLogo from '../../assets/setup-tool-logo.svg';
import InstallerIdentification from '../InstallerIdentification';
import ChangeVINSelection from './ChangeVINSelection';
import ReInstallationVerification from './ReInstallationVerification';

enum ChangeVINPage {
    InstallerIdentification,
    ChangeVINSelection,
    ReInstallationVerification,
}

interface ChangeVINProps {
    dashboardLink: React.ReactNode;
}

const ChangeVIN: React.FC<ChangeVINProps> = (props) => {
    const [page, setPage] = useState<ChangeVINPage>(ChangeVINPage.InstallerIdentification);
    const [installerName, setInstallerName] = useState<string>('');
    const [deviceId, setDeviceId] = useState<string>('');
    const history = useHistory();
    const isMobile = useIsMobile();

    const content = (
        <Box
            sx={{
                width: '85%',
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                position: 'relative',
                minHeight: 0,
                flexShrink: 0,
            }}
        >
            <Box
                sx={{
                    width: '60px',
                    mt: 2,
                    mb: 0.5,
                    flexShrink: 0,
                }}
            >
                <img src={SetupToolLogo} alt="Setup Tool Logo" width="100%" />
            </Box>
            <Box sx={{ width: '200px', flexShrink: 0, mb: 2 }}>
                <img src={OpenEyesLogo} alt="OpenEyes Logo" width="100%" />
            </Box>
            <Box
                sx={{
                    width: '100%',
                    height: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    minHeight: 0,
                }}
            >
                {page === ChangeVINPage.InstallerIdentification ? (
                    <InstallerIdentification
                        installerName={installerName}
                        setInstallerName={setInstallerName}
                        onNext={() => {
                            setPage(ChangeVINPage.ChangeVINSelection);
                        }}
                        dashboardLink={props.dashboardLink}
                    />
                ) : null}
                {page === ChangeVINPage.ChangeVINSelection ? (
                    <ChangeVINSelection
                        installerName={installerName}
                        onBack={() => {
                            setPage(ChangeVINPage.InstallerIdentification);
                        }}
                        onSuccess={(id: string, isNewInstallation: boolean) => {
                            if (isNewInstallation) {
                                setDeviceId(id);
                                setPage(ChangeVINPage.ReInstallationVerification);
                            } else {
                                history.push('/tasks');
                            }
                        }}
                    />
                ) : null}
                {page === ChangeVINPage.ReInstallationVerification ? (
                    <ReInstallationVerification
                        installerName={installerName}
                        deviceId={deviceId}
                        onComplete={() => {
                            history.push('/tasks');
                        }}
                        dashboardLink={props.dashboardLink}
                    />
                ) : null}
            </Box>
        </Box>
    );

    const mobileContainer = (
        <Box
            sx={{
                width: '100%',
                height: '100%',
                backgroundColor: '#fff',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                overflow: 'auto',
                minHeight: 0,
            }}
        >
            {content}
        </Box>
    );

    const desktopContainer = (
        <Card
            sx={{
                width: '100%',
                maxWidth: '400px',
                height: '100%',
                maxHeight: '800px',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                overflow: 'auto',
            }}
        >
            {content}
        </Card>
    );

    return (
        <Dialog id="change-vin-dialog" open={true} fullScreen>
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    width: '100%',
                    height: '100%',
                }}
            >
                {isMobile ? mobileContainer : desktopContainer}
            </Box>
        </Dialog>
    );
};

export default ChangeVIN;
